import { Typography } from "@material-ui/core";
import { emailDecryption } from "helpers/emailDecryption";
import { observer } from "mobx-react";
import { EventStatus } from "models/thorEventModels/EventDetails";
import React from "react";
import { useStore } from "store/StoreConfigs";
import { assignedUsersStyles } from "./AssignedUsersStyles";

export default observer(function AssignedUsers() {
    const classes = assignedUsersStyles();
    const { thorEventViewStore } = useStore();
    return (
        <div className={classes.main}>
            {thorEventViewStore.eventDetails.eventStatusId === EventStatus.ReOpened ? (
                <Typography>
                    <span style={{ fontWeight: 500 }}>Event re-opened by:</span>{" "}
                    {emailDecryption(thorEventViewStore.eventDetails.qaUserId)}
                </Typography>
            ) : (
                <>
                    <Typography variant="h4" style={{ float: "right" }}>
                        Assigned
                    </Typography>
                    <div style={{ marginTop: "30px" }}>
                        <Typography>
                            Reviewer - {emailDecryption(thorEventViewStore.eventDetails.reviewerUserId)}
                        </Typography>
                        {thorEventViewStore.eventDetails.qaUserId && (
                            <Typography>QA - {emailDecryption(thorEventViewStore.eventDetails.qaUserId)}</Typography>
                        )}
                    </div>
                </>
            )}
        </div>
    );
});
